<script setup lang="ts">
defineProps<{
  href: string
  provider: SocialProvider
  label?: string
  size?: string
}>()

const mapping = {
  facebook: 'fab:facebook-f',
  instagram: 'fab:instagram',
  linkedin: 'fab:linkedin-in',
  x: 'fab:x-twitter',
  tiktok: 'fab:tiktok',
  youtube: 'fab:youtube',
} satisfies Record<SocialProvider, string>
</script>

<template>
  <a
    :href="href"
    :aria-label="label || `Lenke til Aschehougs ${provider}-side`"
    class="flex items-center rounded-full p-[0.3rem] leading-none hover:contrast-75"
  >
    <UIcon
      :name="mapping[provider]"
      :size="size"
      class="aspect-square w-full"
    />
  </a>
</template>
